// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import Link from "next/link";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../../containers/login/domain/store/AuthStore.mjs";
import * as HomeStoreEn$PorterinFeature from "../../../../containers/home/domain/store/HomeStoreEn.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as HeaderModuleScss from "../styles/Header.module.scss";
import * as HeaderHelper$PorterinFeature from "../../domain/helper/HeaderHelper.mjs";
import * as PageviewStore$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/store/PageviewStore.mjs";
import * as OrderHistoryStore$PorterinFeature from "../../../../containers/order-history/domian/store/OrderHistoryStore.mjs";
import * as LanguageSelectorCmp$PorterinFeature from "../../../language-selector/view/components/LanguageSelectorCmp.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";

var styles = HeaderModuleScss;

function SecondaryLinksComponent(Props) {
  var is_authenticated = Props.is_authenticated;
  var order_history = Props.order_history;
  var onTrackHandler = Props.onTrackHandler;
  var set_user = Props.set_user;
  var set_is_authenticated = Props.set_is_authenticated;
  var set_is_mobile_menu_open = Props.set_is_mobile_menu_open;
  var support_link = Props.support_link;
  var language_selector = Props.language_selector;
  var router = Router.useRouter();
  var enableDesktopBkf = LocaleHelpers$PorterinUtils.enableDesktopBookingFlow(router.locale);
  var tmp;
  if (is_authenticated && enableDesktopBkf) {
    var tmp$1;
    if (typeof order_history === "number" || order_history.TAG !== /* Live */1) {
      tmp$1 = null;
    } else {
      var match = order_history._0.length;
      tmp$1 = match !== 0 ? React.createElement("div", {
              className: styles["live-orders"],
              onClick: (function (param) {
                  Curry._1(onTrackHandler, undefined);
                })
            }, React.createElement("div", {
                  className: styles.dot
                }), OrderHistoryStore$PorterinFeature.live_orders_text) : null;
    }
    tmp = React.createElement("div", {
          className: styles["menu-item-container"]
        }, tmp$1, React.createElement("div", {
              className: styles.logout,
              onClick: (function (param) {
                  HeaderHelper$PorterinFeature.logoutHandler(set_user, set_is_authenticated, set_is_mobile_menu_open);
                })
            }, AuthStore$PorterinFeature.Profile.logout_button));
  } else {
    tmp = React.createElement(React.Fragment, undefined, React.createElement(Link, {
              href: support_link.link,
              children: support_link.label,
              className: styles["secondary-link"],
              onClick: (function (param) {
                  PublishEventsHelper$PorterinFeature.publishEvents(PageviewStore$PorterinFeature.ga_header_event_prefix, HomeStoreEn$PorterinFeature.ga_header_specific_link_action, support_link.label);
                })
            }));
  }
  return React.createElement("div", {
              className: styles["secondary-link-container"]
            }, tmp, language_selector.locales.length !== 0 ? React.createElement(LanguageSelectorCmp$PorterinFeature.make, {
                    content: language_selector
                  }) : null);
}

var make = SecondaryLinksComponent;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
